export const CharactersInitialState = {
  data: {
    charactersConfig: [],
    charactersElementsUUID: [],
    characterStates: {},
    selectedCharacterUUID: null
  },
}
